__turbopack_context__.v({
  "detailWrapper": "ewPYla_detailWrapper",
});
